"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FacebookLogo = _interopRequireDefault(require("./facebook/FacebookLogo"));
var _TikTokLogo = _interopRequireDefault(require("./tiktok/TikTokLogo"));
var _TwitterLogo = _interopRequireDefault(require("./twitter/TwitterLogo"));
var _TwitchLogo = _interopRequireDefault(require("./twitch/TwitchLogo"));
var _YoutubeLogo = _interopRequireDefault(require("./youtube/YoutubeLogo"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TenantIcon = function TenantIcon(props) {
  var tenantIcons = {
    facebookLogo: _FacebookLogo["default"],
    tiktokLogo: _TikTokLogo["default"],
    twitchLogo: _TwitchLogo["default"],
    twitterLogo: _TwitterLogo["default"],
    youtubeLogo: _YoutubeLogo["default"]
  };
  var IconName = tenantIcons[props.name];
  return /*#__PURE__*/_react["default"].createElement(IconName, props);
};
TenantIcon.propTypes = {
  name: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = TenantIcon;